<template>
    <Banner v-if="!FEATURE('main.e2ee') && !loading && !noticeOff"
        :text="$tc('totp.increaseSecurity')"
        :btnText="$tc('totp.learnMore')"
        @btnClick="learnMore"
        @closeClick="closeTips" />
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import Banner from './banner.vue';
import user from '@/api/user';
import { fetchIsHadSubAndNotExpiredProvider } from '@/service/dashboard';
import store from '@/store';
export default Vue.extend({
    components: {
        Banner
    },
    data () {

        return {
            loading: true,
            noticeOff: true
        };

    },
    async created () {

        try {

            // 关闭 e2ee FEATURE
            if ( this.FEATURE( 'main.e2ee' )) {

                return;

            }
            // 不显示
            this.noticeOff = localStorage.getItem( 'e2ee_notice_off' ) === 'true' ||
            await this.getContractIsOff() ||
            !(
                // 已开启套餐且没有过期
                await this.hadSubAndNotExpired() &&
                // 未开启 e2ee
                !( await this.getCMKIsEnforce())
            );

        } finally {

            this.loading = false;

        }

    },
    methods: {
        learnMore (): void {

            window.open( `${config.accountCenterE2EEManagerUrl}&redirect_uri=${encodeURIComponent( window.location.href )}`, '_self' );

        },
        async closeTips (): Promise<void> {

            this.noticeOff = true;
            localStorage.setItem( 'e2ee_notice_off', Number( this.noticeOff ).toString());
            try {

                await user.agreeContract( 'e2ee_notice_off', 'e2ee.close_tip' );

            } catch ( e ) {

                console.error( e );

            }

        },
        async getContractIsOff (): Promise<any>  {

            try {

                const contractData = await user.getContractVersion( 'e2ee_notice_off' );

                return contractData.items.every( item => item.actions.some( x => x === 'e2ee.close_tip' ));

            } catch ( e ) {

                console.error( e );
                return false;

            }

        },
        hadSubAndNotExpired (): any {

            return fetchIsHadSubAndNotExpiredProvider.consumeGet();

        },
        async getCMKIsEnforce (): Promise<boolean> {

            await store.dispatch( 'initGetCMKS' );
            return Boolean( this.$store.state.enforcedCMK );

        }
    }
});
</script>
<style></style>
